import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import DashboardShell from "@/components/DashboardShell";
import { AptitudeReportView } from "@/components/aptitude/AptitudeReportView";
import { Button } from "@/components/ui/button";
import { ArrowLeft, LayoutDashboard, Users2, UserCog, ScrollText, PlayCircle, Mail, FileBadge, BarChart3, BookOpen, Layers, Loader2 } from "lucide-react";

const LINKS = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard, testId: "nav-admin-dashboard" },
  { to: "/admin/executives", label: "Marketing Executives", icon: UserCog, testId: "nav-admin-executives" },
  { to: "/admin/students", label: "Students", icon: Users2, testId: "nav-admin-students" },
  { to: "/admin/inbox", label: "Inbox", icon: Mail, testId: "nav-admin-inbox" },
  { to: "/admin/audit", label: "Audit Log", icon: ScrollText, testId: "nav-admin-audit" },
  { to: "/admin/sample-report", label: "Sample Report", icon: FileBadge, testId: "nav-admin-sample-report" },
  { to: "/admin/analytics", label: "Analytics", icon: BarChart3, testId: "nav-admin-analytics" },
  { to: "/admin/how-it-works", label: "How It Works", icon: BookOpen, testId: "nav-admin-how-it-works" },
  { to: "/admin/questions", label: "Question Bank", icon: Layers, testId: "nav-admin-questions" },
  { to: "/me/demo", label: "Demo Mode", icon: PlayCircle, testId: "nav-admin-demo" },
];

export default function AdminAptitudeReport() {
  const { studentId } = useParams();
  const navigate = useNavigate();
  const [report, setReport] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get(`/admin/students/${studentId}/aptitude-report`).then((res) => setReport(res.data)).catch((e) => {
      setError(e?.response?.data?.detail || "Aptitude Test report not available yet");
    }).finally(() => setLoading(false));
  }, [studentId]);

  return (
    <DashboardShell links={LINKS} activePath="/admin/students">
      <Button variant="ghost" data-testid="admin-aptitude-back-button" onClick={() => navigate("/admin/students")} className="text-slate-500 mb-6">
        <ArrowLeft className="h-4 w-4 mr-2" /> Back to Students
      </Button>
      {loading && <Loader2 className="h-5 w-5 animate-spin text-indigo-500" />}
      {!loading && error && <p className="text-slate-400" data-testid="admin-aptitude-report-error">{error}</p>}
      {report && <AptitudeReportView report={report} />}
    </DashboardShell>
  );
}
